import { AchooInputComponent } from '../achoo-input/achoo-input.component';
var AchooValidationAlertsComponent = /** @class */ (function () {
    function AchooValidationAlertsComponent() {
    }
    Object.defineProperty(AchooValidationAlertsComponent.prototype, "errorMessages", {
        get: function () {
            return this.component.errors;
        },
        enumerable: true,
        configurable: true
    });
    AchooValidationAlertsComponent.prototype.getMessage = function (error) {
        return error.message;
    };
    return AchooValidationAlertsComponent;
}());
export { AchooValidationAlertsComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-validation-alerts/achoo-validation-alerts.component.ts.pre-build-optimizer.js